<template>
  <div
    data-pendo-ds="text_area_input"
    :style="{ width, 'max-width': '100%' }"
  >
    <label>
      <div class="header">
        <InputLabel
          v-if="label"
          :info="info"
          :label="label"
          :required="required"
        />
        <span
          v-if="maxLength > 0"
          class="body-s-regular character-count"
        >
          {{ value.length }}/{{ maxLength }}
        </span>
      </div>

      <textarea
        class="body-s-regular cr-br-small"
        :class="{
          'error': error,
        }"
        :data-testid="`${id}_text_area_input`"
        :disabled="disabled"
        :placeholder="placeholder"
        :style="{ height: height, maxHeight: maxHeight}"
        :value="value"
        v-bind="maxLength > 0 ? { maxLength: maxLength } : {}"
        @blur="$emit('blur', $event)"
        @input="$emit('update:value', $event.target.value)"
      />
    </label>
    <slot
      v-if="!error"
      name="footer"
    >
      <div class="label-s-regular footer">
        {{ subtext }}
      </div>
    </slot>
    <slot name="errors" />
  </div>
</template>

<script>
import InputLabel from './InputLabel.vue'

export default {
  name: 'TextAreaInput',
  components: {
    InputLabel,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '100%',
    },
    maxLength: {
      type: Number,
      default: 0,
    },
    subtext: {
      type: String,
      default: '',
    },
    info: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: 'auto',
    },
    maxHeight: {
      type: String,
      default: 'none',
    },
  },
  emits: ['update:value', 'blur'],
}
</script>

<style scoped lang="scss">
label, textarea {
  display: block;
  margin: 0;
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--space-1);
}

.footer {
  margin-top: var(--space-2);
  margin-left: var(--space-2);
  color: var(--pepper-700);
}

.character-count {
  color: var(--pepper-700);
}

textarea {
  width: 100%;
  min-height: 75px;
  margin-top: var(--space-1);
  padding: var(--space-3) var(--space-2);
  border: 1px solid var(--pepper-300);
  outline: none;
  resize: vertical;

  &:disabled {
    color: var(--pepper-600);
    background-color: var(--pepper-200);
  }

  &:focus {
    border-color: var(--blueberry-1000);
  }

  &::placeholder {
    color: var(--pepper-600);
  }

  &.error {
    border: 1px solid var(--chicago-dog-red-1000);
    &:focus-visible {
      outline: 2px solid var(--blueberry-300);
    }
  }
}
</style>
